import {
  path
} from './const';
import Splide from '@splidejs/splide';


export const getMainProducts = function (elem) {
  const splide = elem.querySelector('.products__splide');

  const mainProductsSlider = new Splide(splide, {
    arrowPath: path,
    autoWidth: true,
    pagination: false,
    arrows: false,
    mediaQuery: 'min',
    destroy: true,
    classes: {
      arrows: 'splide__arrows products__arrows',
      arrow: 'splide__arrow products__arrow',
      prev: 'splide__arrow--prev products__arrow--prev',
      next: 'splide__arrow--next products__arrow--next',
    },
    breakpoints: {
      '768': {
        arrows: true,
        destroy: false,
        drag: false,
      },
      '1200': {
        destroy: true,
        arrows: false
      },
    },
  });

  return mainProductsSlider;
};

export const getGoodsProducts = function (elem) {
  const splide = elem.querySelector('.products__splide');
  const goodsProductsSlider = new Splide(splide, {
    arrowPath: path,
    autoWidth: true,
    pagination: false,
    arrows: false,
    mediaQuery: 'min',
    destroy: true,
    classes: {
      arrows: 'splide__arrows products__arrows',
      arrow: 'splide__arrow products__arrow',
      prev: 'splide__arrow--prev products__arrow--prev',
      next: 'splide__arrow--next products__arrow--next',
    },
    breakpoints: {
      '768': {
        arrows: true,
        destroy: false,
        drag: false,
      },
    },
  });

  return goodsProductsSlider;
};
